import { createFileRoute } from '@tanstack/react-router';

import { getPublisherOptions } from '@/module/Publisher';

export const Route = createFileRoute('/_auth/publisher/_publisher/$publisherId/_layout')({
  loader: async ({ params: { publisherId }, context: { queryClient } }) => {
    const publisher = await queryClient.ensureQueryData(getPublisherOptions(publisherId));

    return {
      publisher,
      crumb: publisher.title,
    };
  },
});
